import type { OrderStatus } from "../../entities/order";

// Libellés FR pour affichage UI uniquement.
// Les services manipulent toujours la valeur backend (SCREAMING_SNAKE_CASE).

const LABELS: Record<OrderStatus, string> = {
  PENDING_WALLET_CHECK:  "Vérification du wallet…",
  WALLET_FUNDS_BLOCKED:  "Fonds bloqués",
  AGENT_ASSIGNED:        "Main attribuée",
  AGENT_EN_ROUTE:        "En route vers le marché",
  PURCHASING:            "Achats en cours",
  PURCHASED:             "Achats terminés",
  DELIVERING:            "Livraison en cours",
  DELIVERED:             "Livré",
  PAYMENT_SETTLED:       "Paiement finalisé",
  CANCELLED:             "Annulée",
  DISPUTED:              "En litige",
  REFUNDED:              "Remboursée",
};

export function orderStatusLabel(status: OrderStatus | undefined | null): string {
  if (!status) return "—";
  return LABELS[status] ?? status;
}

// Catégories utiles pour le filtrage côté UI

const ACTIVE_STATUSES = new Set<OrderStatus>([
  "PENDING_WALLET_CHECK",
  "WALLET_FUNDS_BLOCKED",
  "AGENT_ASSIGNED",
  "AGENT_EN_ROUTE",
  "PURCHASING",
  "PURCHASED",
  "DELIVERING",
]);

const FINAL_STATUSES = new Set<OrderStatus>([
  "DELIVERED",
  "PAYMENT_SETTLED",
]);

const FAILED_STATUSES = new Set<OrderStatus>([
  "CANCELLED",
  "DISPUTED",
  "REFUNDED",
]);

export function isActiveStatus(status: OrderStatus): boolean {
  return ACTIVE_STATUSES.has(status);
}

export function isFinalStatus(status: OrderStatus): boolean {
  return FINAL_STATUSES.has(status);
}

export function isFailedStatus(status: OrderStatus): boolean {
  return FAILED_STATUSES.has(status);
}
